import { Component, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { ProfileService } from '../../services/profile.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-access-pending',
  imports: [ButtonModule],
  templateUrl: './access-pending.component.html',
  styleUrl: './access-pending.component.scss',
})
export class AccessPendingComponent {
  private profileService: ProfileService = inject(ProfileService);
  private authService: AuthService = inject(AuthService);

  currentLanguage: string = 'en';

  logout(): void {
    this.profileService.tourGuideUpdate({ tour_skipped: false }).subscribe({
      next: () => {
        console.log('Tour skip flag reset on backend');

        this.authService.logout();

        this.currentLanguage = 'en';
      },
      error: (err) => {
        console.error('Failed to reset tour skip:', err);

        this.authService.logout();

        this.currentLanguage = 'en';
      },
    });
  }
}
